import React from 'react';
import { SmileOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/dashboard');
  };

  return (
    <Result
      status="404"
      title="Trang không tồn tại"
      subTitle="Xin lỗi, trang này không tồn tại hoặc đang được cập nhật."
      extra={
        <Button type="primary" onClick={handleNavigate}>
          Quay lại trang chủ
        </Button>
      }
    />
  );
};

export default NotFound;
